export const ScormType = {
    SCORM_1_2: "scorm12",
    SCORM_1_3: "scorm2004"
};
